import { Box } from 'reflexbox';
import styled, { DefaultTheme } from 'styled-components';

import { tokens } from '../theme/tokens';

type Props = {
	size?: number;
	color?: string;
};

const resolveColor = (props: { color?: string; theme: DefaultTheme }) => {
	if (props.color && props.color in props.theme.colors) {
		return props.theme.colors[props.color as keyof typeof props.theme.colors];
	}
	return props.color || tokens.icon.primary;
};

export const IconWrapper = styled(Box)<Props>`
	width: ${(props) => props.size || 20}px;
	height: ${(props) => props.size || 20}px;
	color: ${resolveColor};

	svg {
		width: 100%;
		height: 100%;
		display: block;
		color: inherit;
	}
`;

export const InlineIconWrapper = styled(IconWrapper)<{ translateY?: number }>`
	display: inline-block;
	vertical-align: middle;
	transform: translateY(${(props) => props.translateY || 0}px);
`;
